import { z } from "zod";
import { PageBlockImageReference } from "../elements";

export const DocumentationLinkPreview = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  thumbnail: PageBlockImageReference.optional(),
});

export type DocumentationLinkPreview = z.infer<typeof DocumentationLinkPreview>;
